export default __webpack_public_path__ + "static/media/assist_web-xs@2x.03df53b4.webp";